<template>
  <H5 v-if="isMobile" />
  <PC v-else />
</template>

<script lang="ts" setup>
import { api } from '~/apis/back/services/Api'
import { ENUM_EventType, ENUM_PageName } from '~/enums'
import ogImageUrl from '~/assets/logo.png'
import type { TabSwitchEvent } from '~/types/event-tracking'

const isMobile = useMobileByScreen()

definePageMeta({
  pageCategory: ENUM_PageName.RankPage,
})

const H5 = defineAsyncComponent(() => import('@/pages/mobile/rank/index.vue'))
const PC = defineAsyncComponent(() => import('@/pages/desktop/rank/index.vue'))

const userStore = useUserStore()
const route = useRoute()
const { locale } = useLocale()

const {
  cityData,
  currentTab,
  rankTypeList,
  queryData,
} = useRank()

const { t } = useI18n()

useSeoMeta({
  title: () => t('key.city.rank.page.meta.title', [cityData.value.cityName]),
  description: () => t('key.city.rank.page.meta.desc', [cityData.value.cityName]),
  ogImageUrl,
})

useAutoScrollTop()
cityData.value.cityName = route.params.destinationName as string || ''
cityData.value.cityId = route.params.destinationId as string || ''
cityData.value.countryCode = route.params.countryCode as string || ''
await Promise.all([queryData()])

watch([
  () => userStore.userInfo.currency,
], () => {
  queryData()
})

watch([
  () => route.params.destinationId,
], () => {
  cityData.value.cityName = route.params.destinationName as string || ''
  cityData.value.cityId = route.params.destinationId as string || ''
  cityData.value.countryCode = route.params.countryCode as string || ''
  queryData()
})

watch(() => currentTab.value, (newVal, oldVal) => {
  trackEvent<TabSwitchEvent>({
    event: ENUM_EventType.TabSwitch,
    tab_id: `${newVal}`,
    tab_name: rankTypeList.find(item => item.rankType === newVal)?.rankTypeName ?? '',
    previous_tab_id: `${oldVal}`,
    previous_tab_name: rankTypeList.find(item => item.rankType === oldVal)?.rankTypeName ?? '',
  })
})

watch(() => locale.value, async () => {
  const res = await api.regionSearchPost({ cityId: Number(route.params.destinationId as string) })
  cityData.value.cityName = res.data.value?.data?.[0]?.cityName || route.params.destinationName as string || ''
}, { immediate: true })
</script>
